import { OnInit, Pipe, PipeTransform, OnChanges, Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { ListFilterPipe } from '../pipes/list-filter.pipe';
import { Storage } from '@c4/core';
import { UIModule } from '@c4/ui';
import { DiscoveryService, ConnectedDeviceService, CustomDeviceService } from '../services';

@Component({
  selector: 'list-selector',
  templateUrl: './list-selector.html',
  styleUrls: ['./list-selector.less']
})
export class ListSelectorComponent implements OnInit {

  @Input() listSource: Array<any>;
  @Input() displayField: any;
  @Input() brokerHost: string;
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();
  @Output() sortByFieldChange: ReplaySubject<string> = new ReplaySubject<string>();
  @Output() sortOrderFieldChange: ReplaySubject<string> = new ReplaySubject<string>();

  filterText: string;
  selectedDeviceToRemove : any;
  showConfirmRemoveCustomDevice : boolean;
  sortByValue: string;
  sortOrderValue: string;

  private sortOrderFields = {
    asc: 'Ascending',
    desc: 'Descending'
  }

  private sortByFields = {
    name: 'Name',
    ip: 'IP Address'
  }

  constructor(private storage: Storage, private store: Store<any>,
    private discoService: DiscoveryService, 
    private connectedDeviceService: ConnectedDeviceService,
    private customDeviceService: CustomDeviceService) {
    this.displayField = '';
    this.sortByFieldChange.next('name');
    this.sortByValue = 'name';
    this.sortOrderFieldChange.next('desc');
    this.sortOrderValue = 'desc';
    this.selectedDeviceToRemove = null;
    this.showConfirmRemoveCustomDevice = false;
    this.filterText = '';
  }

  ngOnInit() {
    // restore filter from store
    this.store.filter(a => a.discoveredDevices).take(1).subscribe((discoDevices: any) => {
      if ((discoDevices !== undefined) && (discoDevices.discoveredDevices !== undefined) &&
        (discoDevices.discoveredDevices.discoveredDevicesFilter !== undefined) &&
        (discoDevices.discoveredDevices.discoveredDevicesFilter.filter !== undefined))
        this.filterText = discoDevices.discoveredDevices.discoveredDevicesFilter.filter;
    });
  }

  getTitle(item: any): string {
    let title: string = this.getLabel(item);
    // chop off last 13 chars
    if ((!item.isCustom) && (title.indexOf("-") > -1))
      title = title.substring(0, title.length - 13);

    let maxlength = 25;
    if (item.isCustom) // add ellipses - make room for the 'x' for removing a custom device
      maxlength = 21;

    if (title.length >= maxlength)
      return title.substring(0, maxlength-1) + "&hellip;";
    else
      return title;
  }

  getLabel(item: any): string {
    if (item[this.displayField].length > 40)
      return item[this.displayField].substring(0, item[this.displayField].length - 40) + "&hellip;";
    else
      return item[this.displayField];
  }

  itemClicked(item: any) {
    this.selected.next(item);
  }

  onClickConfirmRemoveDevice(event : any, device : any) {
    event.stopPropagation();
    this.selectedDeviceToRemove = device;
    this.showConfirmRemoveCustomDevice = true;
  }

  onClickRemoveDevice() {
    if (this.selectedDeviceToRemove != null) {
      this.customDeviceService.removeCustomDevice(this.selectedDeviceToRemove);
      this.selectedDeviceToRemove = null;
    }
    this.showConfirmRemoveCustomDevice = false;
  }

  onChangeFilter(event: any) {
    this.filterText = event;
    this.discoService.updateFilter(this.filterText);
  }

  // --- sort by
  sortByChanged(event: any) {
    this.sortByFieldChange.next(event);
    this.sortByValue = event;
  }

  // --- sort order desc/asc
  sortOrderChanged(event: any) {
    this.sortOrderFieldChange.next(event);
    this.sortOrderValue = event;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/list-selector/list-selector.ts